import { ProductMediaPerspective, ProductMediaTypes } from "@is/constants";
import { TrackingEventTypes } from "@is/services/EventTracking";
import { SelectionColorVariantInfo, WidgetType } from "@is/types";

export const WIDGET_TITLE_MAP = {
  [WidgetType.SimilarProducts]: "You may also like",
  [WidgetType.CompleteLook]: "Complete the look",
  [WidgetType.ShopLook]: "Shop the look",
  [WidgetType.AllColors]: "All colors",
  [WidgetType.HowAboutThese]: "How about these?",
  [WidgetType.AllItems]: "All items",
  [WidgetType.HowToWearIt]: "How to wear it",
};

export const ANIMATION_DURATION = 1500;

export const PAGE_SIZE = 40;
export const NEXT_PAGE_SIZE = 20;

export enum PRODUCT_DETAILS_SCROLL_OFFSET {
  FirstItem = `calc(-1 * (var(--space-80) + var(--space-6)))`,
  OtherItems = `calc(-1 * var(--space-40))`,
}

export const ADDITIONAL_OFFSET = 100;

export const PACK_SHOT_001 = "_001";
export const PACK_SHOT_002 = "_002";

export const MEDIA_SLIDER_ORDER_RULES = [
  {
    type: ProductMediaTypes.ModelShot,
    perspective: ProductMediaPerspective.Front,
  },
  {
    type: ProductMediaTypes.ModelShot,
    perspective: ProductMediaPerspective.FrontFull,
  },
  { type: ProductMediaTypes.ModelShot },
  {
    type: ProductMediaTypes.PackShot,
    perspective: ProductMediaPerspective.Front,
  },
  {
    type: ProductMediaTypes.PackShot,
    perspective: ProductMediaPerspective.Back,
  },
  { type: ProductMediaTypes.PackShot },
];

export const COLOR_THUMBNAILS_ORDER_RULES = [
  {
    type: ProductMediaTypes.PackShot,
    perspective: ProductMediaPerspective.Front,
  },
  {
    type: ProductMediaTypes.ModelShot,
    perspective: ProductMediaPerspective.Front,
  },
];

// RecommendationWidgetOrderRules
export const RECOMMENDATION_WIDGET_ORDER_RULES = [
  {
    type: ProductMediaTypes.PackShot,
    perspective: ProductMediaPerspective.Front,
  },
  {
    type: ProductMediaTypes.ModelShot,
    perspective: ProductMediaPerspective.Front,
  },
  {
    type: ProductMediaTypes.PackShot,
    perspective: ProductMediaPerspective.FrontAngled,
  },
  {
    type: ProductMediaTypes.PackShot,
  },
  {
    type: ProductMediaTypes.ModelShot,
    perspective: ProductMediaPerspective.Front,
  },
  {
    type: ProductMediaTypes.ModelShot,
  },
];

export const SELECTION_WIDGET_TYPES = {
  [WidgetType.SimilarProducts]:
    TrackingEventTypes.SelectColorVariantFromSimilarStyles,
  [WidgetType.CompleteLook]:
    TrackingEventTypes.SelectColorVariantFromCompleteLook,
  [WidgetType.ShopLook]: TrackingEventTypes.SelectColorVariantFromShopLook,
  [WidgetType.HowAboutThese]:
    TrackingEventTypes.SelectColorVariantFromHowAboutThese,
  [WidgetType.Collection]: TrackingEventTypes.SelectColorVariantFromCollection,
  [WidgetType.AllColors]: TrackingEventTypes.SelectColorVariantFromAllColors,
  [WidgetType.AllItems]: TrackingEventTypes.SelectColorVariantFromAllItems,
  [WidgetType.HowToWearIt]: TrackingEventTypes.SelectColorVariantFromHTWI,
};

export const SELECTION_VIEW_MORE_TYPES = {
  [WidgetType.SimilarProducts]:
    TrackingEventTypes.ViewMoreFromSimilarStylesClick,
  [WidgetType.CompleteLook]: TrackingEventTypes.ViewMoreFromCompleteLookClick,
  [WidgetType.ShopLook]: TrackingEventTypes.ViewMoreFromShopLookClick,
  [WidgetType.HowAboutThese]: TrackingEventTypes.ViewMoreFromHowAboutTheseClick,
  [WidgetType.Collection]: TrackingEventTypes.ViewMoreFromCollectionClick,
  [WidgetType.AllColors]: TrackingEventTypes.ViewMoreFromAllColorsClick,
  [WidgetType.AllItems]: TrackingEventTypes.ViewMoreFromAllItemsClick,
};

export const SELECTION_COLOR_VARIANT_INFO: SelectionColorVariantInfo = {
  length: TrackingEventTypes.SelectLength,
  size: TrackingEventTypes.SelectSize,
  colorVariantId: TrackingEventTypes.SelectColorVariant,
};

export enum BestMatchType {
  Multi = "multi",
  Id = "id",
  Partial = "id_partial",
}

export const PRODUCT_ROW_SIZE = 4;

export enum PackType {
  ModelShot = "model-shot",
  Accessory = "pack-accessory",
  BottomL0 = "pack-bottom-l0",
  BottomL1 = "pack-bottom-l1",
  Multi = "pack-multi",
  OnePieceL0 = "pack-one-piece-l0",
  OnePieceL1 = "pack-one-piece-l1",
  Shoes = "pack-shoes",
  TopBottom = "pack-top-bottom",
  TopL0 = "pack-top-l0",
  TopL1 = "pack-top-l1",
  TopL2 = "pack-top-l2",
  TopL3 = "pack-top-l3",
  TopL4 = "pack-top-l4",
  TopL5 = "pack-top-l5",
  TopL6 = "pack-top-l6",
  TopL7 = "pack-top-l7",
  Unknown = "pack-unknown",
}
